<template>
  <div>
    <div class="page-content">
      <div class="container">
        <!-- <div class="row justify-content-center">
          <div class="card card-body col-6 " style="width:250px">
          <h5>Your PayID: <h5 class="font-mid my-1">{{$route.params.payId}}</h5></h5>
          </div>
          </div> -->
        <div
          class="card card-body"
          style="border-radius:10px;border-left:#2C80FF 4px solid;border-right:#2C80FF 4px solid"
        >
          <h2 style="text-align:center" class="">
            Addresses Integrated with your PayID
          </h2>
          <h5 style="text-align:center;overflow:wrap;font-size:18px" class="">
            Your PayID: <span style="color:#253992" class=" font-semibold">{{ $route.params.payId }}</span>
             <btn
                      v-clipboard="$route.params.payId"
                      class="ml-2"
                      @success="success"
                      style="cursor:pointer"
                      @error="failed"
                    >
                      <em
                        style="background:transparent"
                        class="fas fa-copy"
                      ></em>
                    </btn>
          </h5>
          <vue-good-table
            v-if="$store.state.loading == false"
            style="width:auto;z-index:0;border-radius:10px;"
            :columns="columns"
            :sort-options="{
              enabled: true,
            }"
           :search-options="{
                    enabled: true,
                    externalQuery: search,
                    skipDiacritics: true,
                    searchFn: searchData,
                    placeholder:
                      'Search by payment network',
                  }"
            :rows="details"
            :pagination-options="{
              enabled: true,
              mode: 'records',
              perPage: 4,
              position: 'bottom',
              perPageDropdown: [5, 3, 7, 10, 15, 20],

              setCurrentPage: 1,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'Rows per page',

              pageLabel: 'page', // for 'pages' mode
              allLabel: 'All',
              dropdownAllowAll: true,
            }"
          />
          <button @click="openPayIdModal" class="btn btn-dark-alt my-1">
            <em class=" btn-icon fa fa-plus mr-2"></em> Integrate new address
          </button>
        </div>
      </div>
    </div>

    <div
      aria-hidden="true"
      data-backdrop="false"
      class="modal fade"
      style="margin-top:5%"
      id="payIdModal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">
              Integrate new address to your PayID
            </h4>

            <button type="button" data-dismiss="modal" class="close">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div class="input-item input-with-label">
              <label class="input-item-label">
                Select Network
                <span class="text-danger">*</span>
              </label>
              <select class=" form-control" v-model="network">
                <option value disabled selected>Choose your option</option>
                <option
                  :value="data"
                  v-for="(data, index) in list"
                  :key="index"
                  >{{ data }}</option
                >
              </select>
            </div>

            <div class="input-item input-with-label">
              <label class="input-item-label">
                Select Network Type for the selected network
                <span class="text-danger">*</span>
              </label>
              <select v-model="networkType" class=" form-control">
                <option value disabled selected>Choose your option</option>
                <option
                  :value="data"
                  v-for="(data, index) in types"
                  :key="index"
                  >{{ data }}</option
                >
              </select>
            </div>

            <div class="input-item input-with-label">
              <label class="input-item-label">
                Enter selected Network address
                <span class="text-danger">*</span>
              </label>
              <input v-model="networkAddress" class="input-bordered" />
            </div>
            <div class="input-item input-with-label">
              <label class="input-item-label">
                Enter tag for your address
                <span class="text-danger">*</span>
              </label>
              <input v-model="networkTag" class="input-bordered" />
            </div>
          </div>

          <!-- Modal footer -->
          <div class="modal-footer">
            <button
              @click.prevent="updatePayId"
              type="button"
              class="btn btn-success"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "PayId",
  data() {
    return {
      network: "",
      networkType: "",
      networkAddress: "",
      networkTag: "",
      list: ["XRPL", "BTC", "ETH"],
      types: ["TESTNET", "MAINNET"],
      currentAddress: this.$cookies.get("address"),
      columns: [
        {
          label: "Payment Network",
          field: "paymentNetwork",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Environment",
          field: "environment",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Tag",
          field: "details.tag",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Address",
          field: "details.address",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      detail: undefined,
    };
  },
  asyncComputed: {
    async details() {
      return detail;
    },
  },
  methods: {
       success() {
      this.$toasted.global.my_app_success({
        message: "PayID copied to clipboard",
      });
    },
    failed() {
      this.$toasted.global.my_app_error({
        message: "PayID copied to clipboard",
      });
    },
    openPayIdModal() {
      window.$("#payIdModal").modal({ backdrop: "static", keyboard: false });
    },
     searchData(row, col, cellValue, searchTerm) {
      console.log(searchTerm);
      return (
        row.paymentNetwork.toLowerCase().startsWith(searchTerm.toLowerCase())
       
      );
    },

    async updatePayId() {
      this.$store.state.loading = true;
      let key = process.env.VUE_APP_API_KEY;
      let addresses = this.details;
      addresses.push({
        paymentNetwork: this.network,
        environment: this.networkType,
        details: {
          address: this.networkAddress.trim(),
          tag: this.networkTag.trim(),
        },
      });
      try {
        let data = await axios({
          url:
            this.$store.state.url +
            "/api/payids" +
            "/" +
            this.$route.params.payId,
          method: "PUT",

          data: {
            addresses: addresses,
          },

          headers: {
            Authorization: "Basic " + key,
          },
        });

        if (data.status == 200) {
          window.$("#payIdModal").modal("hide");
          this.$toasted.global.my_app_success({
            message: data.data.msg,
          });
          await this.fetchAddressDetails();
        }
      } catch (err) {
        console.log(err.response.data.msg);
        await this.fetchAddressDetails();
        this.$toasted.global.my_app_error({
          message: err.response.data.msg,
        });
      } finally {
        this.$store.state.loading = false;
        addresses = undefined;
      }
    },

    async fetchAddressDetails() {
      this.$store.state.loading = true;
      let key = process.env.VUE_APP_API_KEY;
      this.details = [];

      try {
        let data = await axios({
          url: this.$store.state.url + "/api/payids/" + this.currentAddress,
          method: "GET",

          headers: {
            Authorization: "Basic " + key,
          },
        });
        if (data.status == 200) {
          this.details = data.data.data.addresses;
          console.log(this.details);
          // let removeIndex = this.addedParties.indexOf(partyName);

          //   if (removeIndex != -1) {
          //     this.addedParties.splice(removeIndex, 1);
          //   }
          return data.data.data.addresses;
        }
      } catch (err) {
        console.log(err.response.data.msg);
        this.$toasted.global.my_app_error({
          message: err.response.data.msg,
        });
      } finally {
        this.$store.state.loading = false;
      }
    },
  },
  created() {
    this.fetchAddressDetails();
  },
};
</script>
<style scoped>
@import "../assets/css/vendor.bundle.css?ver=104";
@import "../assets/css/style.css?ver=104";
</style>
